import { VALIDATIONS } from './types/upload-video';
import type { ValidationsObject } from './types/upload-video';

export const FEEDBACK_VISIBILITY_STORAGE_KEY = 'transcript-feedback-visibility';
export const VIEW_LIBRARY_VIDEO_MAX_WIDTH = 1440;
export const VIEW_LIBRARY_VIDEO_PLAYER_ASPECT_RATIO = 16 / 9;
export const VIEW_LIBRARY_VIDEO_MIN_PLAYER_HEIGHT = 144;
export const FEEDBACK_HIDE_DURATION_24HRS_AS_MS = 24 * 60 * 60 * 1000; // 24 hours

export const KB = 1024;
export const MB = KB * KB;
const GB = MB * KB;

export const MAX_DURATION_HOURS = 26; // if this changes, you'll need to update the corresponding validation error message
export const MAX_DURATION_SEC = 60 * 60 * MAX_DURATION_HOURS;
export const MAX_KEYFRAME_INTERVAL = 3.2;
export const MAX_FILE_SIZE_GB = 64; // if this changes, you'll need to update the corresponding validation error message
export const MAX_FILE_SIZE = MAX_FILE_SIZE_GB * GB;
export const MAX_PROGRESS_ALLOWED_FOR_BYTE_TRANSFER = 99;
export const SAMPLE_RATE_TABLE = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 8000, 7350];

export const EMBED_ID_MICRO =
  'ZjI5NGZmNmUtNzUxNS00NWQxLWE1NjQtM2YzNjQxODU3OGFhOmQ1M2EzYjg4LTIyNzQtMTFmMS04OGEzLTQ5ZDYyMzllMDNiMA%3D%3D';
export const EMBED_ID_ROD =
  'ZjI5NGZmNmUtNzUxNS00NWQxLWE1NjQtM2YzNjQxODU3OGFhOjE0ZmZlYTlhLTIyNzUtMTFmMS05YjRmLTBmYzFlYzY1MTU3Ng%3D%3D';

export const validations: ValidationsObject = Object.freeze({
  [VALIDATIONS.BACK_END]: 'backendError',
  [VALIDATIONS.NETWORK_ERROR]: 'networkError',
  [VALIDATIONS.NOT_A_VIDEO]: 'notAVideo',
  [VALIDATIONS.INVALID_FORMAT]: 'invalidFormat',
  [VALIDATIONS.INVALID_PIXEL_FORMAT]: 'invalidPixelFormat',
  [VALIDATIONS.INVALID_DIMENSIONS]: 'invalidDimensions',
  [VALIDATIONS.NO_UPLOAD_FILE]: 'noUploadFile',
  [VALIDATIONS.FILE_SIZE_0]: 'fileSizeZero',
  [VALIDATIONS.INVALID_FILE_TYPE]: 'invalidFileType',
  [VALIDATIONS.INVALID_AUDIO_TYPE]: 'invalidAudioType',
  [VALIDATIONS.KEYFRAME_INTERVAL]: 'keyFrameInterval',
  [VALIDATIONS.KEYFRAME_INCONSISTENCY]: 'keyFrameInconsistency',
  [VALIDATIONS.MAX_DURATION]: 'maxDuration',
  [VALIDATIONS.MAX_FILE_SIZE]: 'maxFileSize',
  [VALIDATIONS.MAX_AUDIO_CHANNELS]: 'maxAudioChannels',
  [VALIDATIONS.MAX_AUDIO_BITRATE]: 'maxAudioBitrate',
  [VALIDATIONS.MAX_VIDEO_CHANNELS]: 'maxVideoChannels',
  [VALIDATIONS.MAX_VIDEO_BITRATE]: 'maxVideoBitrate',
  [VALIDATIONS.MAX_VIDEO_BITRATE_WIDE]: 'maxVideoBitrateWide',
  [VALIDATIONS.MAX_VIDEO_BITRATE_4K]: 'maxVideoBitrate4k',
  [VALIDATIONS.MAX_RESOLUTION]: 'maxResolution',
  [VALIDATIONS.MAX_RESOLUTION_4K]: 'maxResolution4k',
  [VALIDATIONS.INVALID_FPS]: 'invalidFps',
  [VALIDATIONS.INVALID_FRAMERATE_MODE]: 'invalidFramerateMode',
  [VALIDATIONS.MAX_GOP]: 'maxGop',
  [VALIDATIONS.INVALID_AUDIO_SAMPLERATE]: 'invalidAudioSamplerate',
  [VALIDATIONS.NO_AUDIO]: 'noAudio',
});

export enum VIEW_ENCODER_VIDEO_TABS {
  CUES,
  AUDIO,
}

export enum VIEW_WEB_VIDEO_TABS {
  CUES,
  AUDIO,
}
